import {
    FETCH_CUSTOMER,
    FETCH_CUSTOMERS,
} from '../actions/customerConfig';


export const initialState = {
    isFetching: true,
    data: null
};

export const customers = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_CUSTOMERS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_CUSTOMERS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const customer = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_CUSTOMER}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_CUSTOMER}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/customerConfig.js